import { Controller } from "@hotwired/stimulus"

// Toolbar button that expands or collapses every capacity-planning site section at once,
// via document-level events the per-site planning-section controllers listen for. Tracks
// the last action to swap the icon and label; starts "expanded" to match the default board.
export default class extends Controller {
  static targets = ["icon", "button"]
  static values = { collapsed: Boolean }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    document.dispatchEvent(
      new CustomEvent(this.collapsedValue ? "planning:collapse-all" : "planning:expand-all"),
    )
  }

  collapsedValueChanged() {
    if (this.hasIconTarget) this.iconTarget.classList.toggle("-rotate-90", this.collapsedValue)
    if (this.hasButtonTarget) {
      const label = this.collapsedValue
        ? this.buttonTarget.dataset.expandLabel
        : this.buttonTarget.dataset.collapseLabel
      this.buttonTarget.title = label
      this.buttonTarget.setAttribute("aria-label", label)
    }
  }
}
